<template>
  <div v-if="dataList.length > 0">
    <div class="pc-recommend-task__divider"></div>
    <div class="pc-recommend-task">
      <div class="pc-recommend-task__header">
        <div class="pc-recommend-task__header-text">
          <div class="pc-recommend-task__title">{{ mainTitle }}</div>
          <div class="pc-recommend-task__subtitle" v-html="subtitle"></div>
        </div>
      </div>

      <div class="pc-recommend-task__body">
        <div class="pc-recommend-task__list">
          <RecommendCard
            v-for="item in dataList"
            :key="item.dataId"
            :card="item"
            @openPcDetail="handleOpenDetail"
            @pcAddPlan="handleAddPlan"
            @updateList="updateList"
          />
          <div v-if="!finished" class="pc-recommend-task__load-more" @click="getMore">
            {{ loading ? '加载中...' : '点击加载更多' }}
          </div>
          <div v-else class="pc-recommend-task__finished">没有更多了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue'
import { getRecommendedList } from '@/api/app-home.js'
import RecommendCard from '@/pages/MobileScheduleAgent/components/recommend-task-drawer/components/recommend-card.vue'

defineOptions({ name: 'PcRecommendTask' })

const emits = defineEmits(['pcAddPlan', 'openPcDetail'])

const page = ref(1)
const pageSize = ref(2)
const pageTotal = ref(0)
const dataList = ref([])
const taskNum = ref(0)
const customerNum = ref(0)
const loading = ref(false)
const finished = ref(false)

const mainTitle = computed(() => {
  return dataList.value.length > 0 ? '已根据跟进为你提炼推荐任务' : '还没有要推荐的任务哦 ~'
})

const subtitle = computed(() => {
  return dataList.value.length > 0
    ? `<span class="text">共</span>
      <span class="highlight"> ${customerNum.value} </span>
      <span class="text">家客户</span>
      <span class="highlight"> ${taskNum.value} </span>
      <span class="text">条推荐待办，快去跟进吧 ~</span>`
    : '<span class="text">完成跟进后将为你自动提炼，快去跟进吧 ~</span>'
})

const updateList = () => {
  page.value = 1
  getList()
}

const getList = async () => {
  loading.value = true
  try {
    const res = await getRecommendedList({
      page: page.value,
      pageSize: pageSize.value
    })
    if (page.value === 1) {
      dataList.value = []
      customerNum.value = res.result.customerNum
      taskNum.value = res.result.taskNum
      await nextTick()
      dataList.value = res.result.list
    } else {
      dataList.value = [...dataList.value, ...res.result.list]
    }
    pageTotal.value = res.result.pageHelper.pageTotal
    finished.value = page.value >= pageTotal.value
  } catch (e) {}
  loading.value = false
}

const getMore = async () => {
  if (loading.value || page.value >= pageTotal.value) {
    loading.value = false
    return
  }
  page.value++
  getList()
}

const handleAddPlan = (detailId) => {
  emits('pcAddPlan', detailId)
}

const handleOpenDetail = (item) => {
  emits('openPcDetail', item)
}

onMounted(() => {
  getList()
})
</script>

<style lang="scss" scoped>
.pc-recommend-task__divider {
  // background: #e5e6eb;
  border-top: 1px dashed #f5e8ff;
  margin-top: 12px;
  margin-bottom: 24px;
}
.pc-recommend-task {
  margin-top: 12px;
  border-radius: 12px;
  background: linear-gradient(330deg, #eef2ff 2%, #f5f3ff 100%);
  box-sizing: border-box;
  border: 1px solid #e5e6eb;
  &__header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
  }

  &__header-text {
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: #323233;
  }

  &__subtitle {
    margin-top: 2px;
    :deep(.text) {
      font-size: 13px;
      line-height: 18px;
      color: #969799;
    }
    :deep(.highlight) {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #323233;
    }
  }

  &__body {
    display: flex;
    position: relative;
    .pc-recommend-task__list {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .pc-recommend-task__load-more,
    .pc-recommend-task__finished {
      flex: 0 0 auto;
      padding: 12px 0;
      text-align: center;
      font-size: 13px;
      line-height: 18px;
      color: #969799;
    }
    .pc-recommend-task__load-more {
      cursor: pointer;
    }
    .empty {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #ffffff;
    }
  }
}
</style>
